import { Avatar as AntdAvatar, Tooltip } from 'antd'
import * as React from 'react'
import { memo, useState } from 'react'

import { AvatarBtnProps, AvatarProps } from './types'
import { stringToColour } from '../helpers'

import * as styles from './Avatar.module.less'

const getInitials = (args: { str: string }): string => {
    const { str } = args
    let initials

    const spaceCount = str.split(' ').length - 1

    if (spaceCount === 0) {
        initials = str.substr(0, 2)
    } else {
        initials =
            str
                ?.split(' ')
                .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
                .join('') || ''.toUpperCase()
    }

    return initials
}

export const Avatar: React.FC<AvatarProps> = memo((props) => {
    const { display, id, picture, size, tooltip, whiteBorder } = props
    const showTooltip = tooltip !== undefined ? tooltip : true
    let initials
    initials = getInitials({ str: display })

    const [isPictureless, setIsPictureless] = useState(!picture)

    React.useEffect(() => {
        setIsPictureless(!picture)
    }, [picture])

    const generateBackgroundColorField =
        props.generateBackgroundColorField || id

    const letterAvatar = (
        <AntdAvatar
            style={{
                background: stringToColour(generateBackgroundColorField)
            }}
            size={size}
        >
            <span
                style={{
                    mixBlendMode: 'exclusion',
                    fontSize: size === 'large' ? 'large' : 'medium',
                    fontWeight: size === 'large' ? 600 : 'normal'
                }}
            >
                {initials}
            </span>
        </AntdAvatar>
    )

    const onError = () => {
        setIsPictureless(true)
        return true
    }

    const picAvatar = <AntdAvatar src={picture} size={size} onError={onError} />

    const style: React.CSSProperties = whiteBorder
        ? React.useMemo(() => {
              return { border: `${whiteBorder}px solid white` }
          }, [whiteBorder])
        : {}

    const avatar = (
        <span className={`${styles.avatarWrapper} avatar`} style={style}>
            <div className={styles.avatarWhiteBackground} />
            {isPictureless ? letterAvatar : picAvatar}
            <div className={styles.avatarOutline} />
        </span>
    )

    return showTooltip ? (
        <Tooltip
            title={
                <React.Fragment>
                    <div>{display}</div>
                    <div>{id}</div>
                </React.Fragment>
            }
            placement="bottomRight"
            mouseEnterDelay={0.3}
            trigger={['click', 'hover']}
        >
            {avatar}
        </Tooltip>
    ) : (
        avatar
    )
})

export const AvatarButton: React.FC<AvatarBtnProps> = (props) => {
    // ommit onAvatarClick, to re-create appropriate props for Acatar without onAvatarClick
    const { onAvatarClick, ...avatarProps } = props

    const onBtnClick = () => {
        if (onAvatarClick) {
            onAvatarClick(props.id)
        } else {
            console.warn('Please provide a onAvatarClick method to AvatarList')
        }
    }
    return (
        <button className={styles.avatarBtn} onClick={onBtnClick}>
            <Avatar {...avatarProps} />
        </button>
    )
}
